export const ONE_SECOND = 1000; // Milliseconds
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;

export const PASSWORD_MIN_LENGTH = 5;

export const FILE_IMPORT_REDIRECT_TIME = 5000;
